import { render, staticRenderFns } from "./touch.vue?vue&type=template&id=6990207a&scoped=true&"
import script from "./touch.vue?vue&type=script&lang=js&"
export * from "./touch.vue?vue&type=script&lang=js&"
import style0 from "./touch.vue?vue&type=style&index=0&id=6990207a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990207a",
  null
  
)

export default component.exports